/* ==========================================================================
   PanelPet > Config
   ========================================================================== */

const config = {
    component: 'PanelPet',
    type: {
        product: 'select-pet',
        weight: 'input-weight',

        extra: {
            toggle: 'toggle-extra',
            length: 'input-extra-length',
            height: 'input-extra-height',
            width: 'input-extra-width'
        }
    },
    css: {
        select: 'select--with-border',
        input: 'input--with-border',
        hidden: 'is-hidden'
    },
    /**
     * Callbacks, they return its component instance and the panel one
     */
    onChangeSelect: () => {},
    onChangeToggle: () => {},
    onChangeInput: () => {}
};

/* Exports */
module.exports = () => config;
